<template>
    <div class="w-full">
        <carousel
            class="plane_carrousel"
            :autoplay="autoplay"
            autoplay-hover-pause
            :per-page="1"
            :pagination-enabled="false"
            style="width: 100%"
            loop
            @input="onCarouselInput($event)"
            :navigate-to="index - 1"
        >
            <slide v-for="(example, index) in planeExamples" :key="index">
                <component :is="!!example.url ? 'a' : 'div'" class="home-plane-examples-bloc" :href="example.url">
                    <img :src="example.thumb_url">
                    <p class="name">
                        {{ example.plane_model.name }}
                    </p>
                    <p class="description">
                        {{ example.description }}
                    </p>
                    <div class="home-plane-examples-bloc-infos">
                        <div class="home-plane-examples-bloc-infos-speed">
                            <img src="/imgs/icons/vitesse.svg">
                            <p class="key">
                                {{ $t('home.speed') }}
                            </p>
                            <p class="value">
                                {{ example.plane_model.vitesseCroisiere }} km/h
                            </p>
                        </div>
                        <div class="home-plane-examples-bloc-infos-passengers">
                            <img src="/imgs/icons/passagers.svg">
                            <p class="key">
                                {{ $t('home.passengers') }}
                            </p>
                            <p class="value">
                                {{ example.plane_model.nbPassagerMax }} max
                            </p>
                        </div>
                    </div>
                </component>
            </slide>
        </carousel>
        <DotNavigation :page-count="planeExamples.length" :value="index" @input="navigateTo($event)" :primary-color="primaryColorSlider" />
    </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import DotNavigation from './DotNavigation.vue';

export default {
    components: {
        Carousel,
        Slide,
        DotNavigation,
    },

    props: {
        planeExamples: Array,
        primaryColorSlider: Boolean,
    },

    data() {
        return {
            index: 1,
            autoplay: true,
        };
    },

    methods: {
        navigateTo(index) {
            this.autoplay = false;
            this.index = index;
        },
        onCarouselInput(event) {
            this.index = typeof event == 'number' ? event + 1 : this.index;
        },
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/PlaneExamplesCarousel.vue